import { RefObject } from 'react';
import { Nullable, useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';

interface SyncHeightOptions {
    shouldSkip: boolean;
}
/**
 * Хук для синхронизации высот для 2 элементов
 * @param srcElement Элемент высоту которого отслеживаем
 * @param dstRef Элемент высоту которого устанавливаем
 */
export function useSyncHeight(
    srcElement: Nullable<HTMLDivElement>,
    dstRef: RefObject<Nullable<HTMLDivElement>>,
    { shouldSkip }: SyncHeightOptions,
) {
    useIsomorphicLayoutEffect(() => {
        if (typeof window === 'undefined' || !window.ResizeObserver) {
            return;
        }

        if (shouldSkip) {
            return;
        }

        const dstElement = dstRef.current;
        if (!srcElement || !dstElement) {
            return;
        }

        let rafId: number | null = null;

        const setPlaceholderHeight = () => {
            const height = srcElement.getBoundingClientRect().height;
            dstElement.style.minHeight = `${height}px`;
            rafId = null;
        };

        const resizeObserver = new ResizeObserver(() => {
            if (rafId) {
                cancelAnimationFrame(rafId);
            }
            rafId = requestAnimationFrame(setPlaceholderHeight);
        });

        resizeObserver.observe(srcElement);
        setPlaceholderHeight();

        return () => {
            resizeObserver.disconnect();
            if (rafId) {
                cancelAnimationFrame(rafId);
            }
        };
    }, [srcElement, shouldSkip]);
}
